import "./Help.css";

const Help = () => {
  return (
    <div className="help">
      <p className="help-label">Telegram Channel:</p>
      <a
        className="help-link"
        href="https://t.me/ProfitOption_support"
        target="_blank"
      >
        @ProfitOption_support
      </a>
    </div>
  );
};

export default Help;
